import i18n from '../i18n';

function inputErrors(value , condition, label){      
    let isNull = !String(value).trim().length;
    let isInt = Number.parseInt(value) == value;
    let isDec = Number(value) == value;
    switch (condition) {
      case "number":
        if (isNull) {
          return null;
        }else{
          if (isInt) {
            return null;
          } else {
            return label + " " + i18n.t("configuration.errors.input.invalid_input.number");
          }
        }
      case "number_&_max_100":           
        if (isInt) {
          if (value > 100) {
            return label + " " + i18n.t("configuration.errors.input.invalid_input.weight_lenght");
          }
          return null;
        } else {
          return label + " " + i18n.t("configuration.errors.input.invalid_input.number");
        }
      case "number_&_not_null":
        if (isNull) {
          return label + " " + i18n.t("configuration.errors.input.required_field");
        }else{
          if (isInt) {
            return null;
          } else{
            return label + " " + i18n.t("configuration.errors.input.invalid_input.number");
          }
        }
      case "not_null":
        if (isNull) {
          return label + " " + i18n.t("configuration.errors.input.required_field");
        } else {
          return null;
        }
      case "number_decimal":
        if (isInt) {
          if (value % 1 != 0) {
            return label + " " + i18n.t("configuration.errors.input.invalid_input.number")
          }
          return null;
        } else {
          return null;
        }
      default:
        return null;
    }
  }

export {inputErrors};